import { apiRequest, apiUrl } from "./http";
import type {
  ClientDecision,
  ProjectContentInput as ContentInput,
  ProjectContent,
} from "./generated/openapi";
export type {
  ContentKind,
  ApplicationStatus,
  ClientDecision,
  ProjectMedia,
  ProjectContentInput as ContentInput,
  ProjectContent,
} from "./generated/openapi";
export const projectContentApi = {
  list: (project: string) =>
    apiRequest<ProjectContent[]>(`/api/projects/${project}/content`),
  create: (project: string, input: ContentInput) =>
    apiRequest<ProjectContent>(`/api/projects/${project}/content`, {
      method: "POST",
      body: JSON.stringify(input),
    }),
  update: (project: string, id: string, input: ContentInput) =>
    apiRequest<ProjectContent>(`/api/projects/${project}/content/${id}`, {
      method: "PATCH",
      body: JSON.stringify(input),
    }),
  decide: (
    project: string,
    id: string,
    decision: ClientDecision,
    note: string,
  ) =>
    apiRequest<ProjectContent>(
      `/api/projects/${project}/content/${id}/decision`,
      { method: "PATCH", body: JSON.stringify({ decision, note }) },
    ),
  upload: (project: string, id: string, file: File) => {
    const body = new FormData();
    body.append("file", file);
    return apiRequest<ProjectContent>(
      `/api/projects/${project}/content/${id}/media`,
      { method: "POST", body },
    );
  },
  removeMedia: (project: string, id: string, media: string) =>
    apiRequest<ProjectContent>(
      `/api/projects/${project}/content/${id}/media/${media}`,
      { method: "DELETE" },
    ),
  mediaUrl: (project: string, id: string, media: string) =>
    apiUrl(`/api/projects/${project}/content/${id}/media/${media}`),
};
